"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = [{
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'axelartestnet',
    client_id: '07-tendermint-213',
    connection_id: 'connection-151'
  },
  chain_2: {
    chain_name: 'osmosistestnet4',
    client_id: '07-tendermint-3319',
    connection_id: 'connection-2807'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-135',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1946',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'junotestnet',
    client_id: '07-tendermint-135',
    connection_id: 'connection-151'
  },
  chain_2: {
    chain_name: 'osmosistestnet4',
    client_id: '07-tendermint-4413',
    connection_id: 'connection-3814'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-140',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-3316',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../../ibc_data.schema.json',
  chain_1: {
    chain_name: 'marstestnet',
    client_id: '07-tendermint-3',
    connection_id: 'connection-2'
  },
  chain_2: {
    chain_name: 'osmosistestnet4',
    client_id: '07-tendermint-3419',
    connection_id: 'connection-2887'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-2083',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'nobletestnet',
    client_id: '07-tendermint-6',
    connection_id: 'connection-6'
  },
  chain_2: {
    chain_name: 'osmosistestnet4',
    client_id: '07-tendermint-4504',
    connection_id: 'connection-3905'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-4',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-3651',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live'
    }
  }]
}];
var _default = exports["default"] = info;